import script from "./RichTextContent.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextContent.vue?vue&type=script&setup=true&lang=js"

import "./RichTextContent.vue?vue&type=style&index=0&id=3eefc5c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eefc5c5"]])

export default __exports__